// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__2NHpR","checkboxCol":"Table_checkboxCol__37A5F","emailCol":"Table_emailCol__O0u4n","actionCol":"Table_actionCol__1B1K8"};